import "./CaptionedImage.css";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import imageUrlBuilder from "@sanity/image-url";
import sanityClient from "../../sanityClient";

const builder = imageUrlBuilder(sanityClient);
function urlFor(source) {
    return builder.image(source);
}

export default function CaptionedImage({ image }) {
    return (
        <div className="captionedImage">
            <Zoom>
                <img src={urlFor(image.imageFile).url()} alt={image.alt || "image"} />
            </Zoom>
            {image.caption && <p className="caption">{image.caption}</p>}
        </div>
    );
}
